<template>
    <div class="calendar">
      <div class="calendar-header">
          <h3 class="month-title">{{ monthTitle }}</h3>
      </div>
      <div class="calendar-grid">
        <!-- Cabeçalho dos dias da semana -->
        <div
          class="weekday"
          v-for="(day, index) in weekdays"
          :key="`weekday-${index}`"
        >
          {{ day }}
        </div>
        <!-- Dias do mês -->
        <div
          v-for="(day, index) in daysInMonth"
          :key="day.date || `empty-${index}`"
          :class="['day', getDayClass(day)]"
          @click="selectDate(day)"
        >
          {{ day.label }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
  name: "CustomCalendar",
  props: {
    availableDates: {
      type: Array,
      required: false,
      default: () => [] // Por padrão, nenhuma data está disponível
    },
    selectedColors: { 
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: String,
      default: null
    },
    allowedDates: {
      type: Function,
      default: () => () => true // Por padrão, todas as datas são permitidas
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    currentMonth:{
        typeof: String,
        default: new Date().getMonth()
    },
    currentYear:{
        typeof: String,
        default: new Date().getFullYear()
    },
    eventTimes: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedDate: this.modelValue, // Data inicial selecionada
      //currentMonth: new Date().getMonth(),
      //currentYear: new Date().getFullYear(),
      weekdays: ["D", "S", "T", "Q", "Q", "S", "S"]
    };
  },
  computed: {
    monthTitle() {
      const monthNames = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
      ];
      return `${monthNames[this.currentMonth]}`;
    },
    daysInMonth() {
      const days = [];
      const firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
      const totalDays = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
      const month = this.currentMonth + 1;

      // Preenche com espaços vazios para alinhar o primeiro dia do mês
      for (let i = 0; i < firstDay; i++) {
        days.push({ label: "", available: false, date: null });
      }

      // Adiciona os dias reais do mês
      for (let day = 1; day <= totalDays; day++) {
        const date = `${this.currentYear}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
        const isAllowed =
          (!this.min || date >= this.min) &&
          (!this.max || date <= this.max) &&
          this.allowedDates(date);

        days.push({
          label: day,
          available: isAllowed && this.availableDates.includes(date),
          date
        });
      }

      return days;
    },
    getEventTimes(){
      return this.eventTimes
    }
  },
  methods: {
    isSelected(date) {
      return this.selectedDate === date;
    },
    selectDate(day) {
      if (day.available) {
        this.selectedDate = day.date;
        this.$emit("input", this.selectedDate); // Emite o evento @input
        //this.$emit("update:vModel", this.selectedDate); // Atualiza o v-model
        this.$emit("update:modelValue", this.selectedDate); // Atualiza o v-model
      }
    },
    getDayClass(day) {
      if (!day.available) return 'disabled-day';

      const events = this.getEventTimes[day.date];
      if (events && Array.isArray(events)) {
        const values = [];

        events.forEach(event => {
          if (!values.includes(event.value)) {
            values.push(event.value);
          }
        });

        values.sort(); // Ordena os valores para manter um padrão consistente

        // Mapeamento das combinações de valores para as classes CSS
        const classMapping = {
          "1": "day red-day",
          "2": "day yellow-day",
          "3": "day green-day",
          "0": "day available",
          "1-2": "day red-yellow-day",
          "1-3": "day red-green-day",
          "0-1": "day red-white-day",
          "2-3": "day yellow-green-day",
          "0-2": "day yellow-white-day",
          "0-3": "day green-white-day",
          "1-2-3": "day red-yellow-green-day",
          "0-1-2": "day red-yellow-white-day",
          "0-1-3": "day red-green-white-day",
          "0-2-3": "day yellow-green-white-day",
          "0-1-2-3": "day red-yellow-green-white-day"
        };

        const key = values.join('-'); // Gera a chave para buscar a classe CSS
        const className = `day ${classMapping[key] || 'available'}`;


        return className; // Retorna a classe correspondente ou 'available' por padrão
      }

      return 'day available'; // Padrão: dia disponível sem seleção
    }
  },
  watch: {
    modelValue(newVal) {
      this.selectedDate = newVal; // Atualiza a data selecionada quando o v-model muda
    },
    eventTimes(newValue) {
        console.log('eventTimes foi atualizado para:', newValue);
    }
  }
};


  </script>
  
  <style scoped>
  .calendar {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: Arial, sans-serif;
  }
  
  .month-title {
    font-size: 24px;
    margin-bottom: 16px;
    color: black;

  }
  
  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 9px;
    width: 100%;
  }
  
  .weekday {
    text-align: center;
    font-weight: bold;
    color: black;
  }
  
  .day {
    width: 39px;
    height: 39px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: white !important;
    color: black;
    font-size: 14px;
    cursor: pointer;
  }
  
  .day.available {
    background-color: white;
  }
  
  .day.selected {
    background-color: #6c63ff;
    color: white;
  }
  
  .day:not(.available) {
    cursor: default;
    opacity: 0.3;
  }

  .day.red-day {
    background-color: #fa9a9a !important;
    color: black;
    opacity: 1;
  }

  .day.yellow-day {
    background-color: #f5e720 !important;
    color: black;
    opacity: 1;
  }

  .day.green-day {
    background-color: #cbd8c7 !important;
    color: black;
    opacity: 1;
  }

  .day.yellow-green-day {
    background: linear-gradient(to bottom, #ffd700 50%, #cbd8c7 50%);
    opacity: 1;
  }

  .day.yellow-white-day {
    background: linear-gradient(to bottom, #ffd700 50%, #fff 50%);
    opacity: 1;
  }

  .day.red-yellow-day {
    background: linear-gradient(to bottom, #fa9a9a 50%, #ffd700 50%);
    opacity: 1;
  }

  .day.red-green-day {
    background: linear-gradient(to bottom, #fa9a9a 50%, #cbd8c7 50%);
    opacity: 1;
  }

  .day.red-white-day {
    background: linear-gradient(to bottom, #fa9a9a 50%, #ffffff 50%);
    opacity: 1;
  }

  .day.green-white-day {
    background: linear-gradient(to bottom, #cbd8c7 50%, #fff 50%);
    opacity: 1;
  }

  .day.red-yellow-green-white-day {
    background: linear-gradient(
      to bottom,
      #fa9a9a 25%,
      #ffd700 25% 50%,
      #cbd8c7 50% 75%,
      #ffffff 75%
    );
    opacity: 1;
  }

  .day.red-yellow-green-day {
    background: linear-gradient(
    to bottom,
    #fa9a9a 33.3%,
    #f5e720 33.3% 66.6%,
    #cbd8c7 66.6%
  );
  opacity: 1;
  }

  .day.red-yellow-white-day {
    background: linear-gradient(
    to bottom,
    #fa9a9a 33.3%,
    #f5e720 33.3% 66.6%,
    #ffff 66.6%
    );
    opacity: 1;
  }

  .day.red-green-white-day {
    background: linear-gradient(
    to bottom,
    #fa9a9a 33.3%,
    #cbd8c7 33.3% 66.6%,
    #ffff 66.6%
    );
    opacity: 1;
  }

  .day.yellow-green-white-day {
    background: linear-gradient(
    to bottom,
    #cbd8c7 33.3%,
    #f5e720 33.3% 66.6%,
    #ffff 66.6%
    );
    opacity: 1;
  }

  .calendar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 16px;
}

  @media screen and (max-width: 768px) {
    .month-title{
      font-size: 20px !important;
      font-weight: 500;
    }
  }

  </style>
  